<!-- TODO: add links to blue words -->
<div class="page">
  <h1>
    <a routerLink="/about">Hello, I'm Anne!<br></a> I’m a product designer/developer <a routerLink="/waivethewait">@WaiveTheWait</a> and <a href="https://www.rbc.com/about-rbc.html" target="_blank">@RBC</a>. 
    I care deeply about designing for well-being and inclusivity.   
  </h1>


  <!-- GALLERY -->
  <input type="radio" id="#All" name="categories" value="#All" checked>
  <input type="radio" id="#ProductDesign" name="categories" value="#ProductDesign">
  <input type="radio" id="#AugmentedReality" name="categories" value="#AugmentedReality">
  <input type="radio" id="#Health" name="categories" value="#Health">
  <input type="radio" id="#Community" name="categories" value="#Community">


  <!-- <ol class="filters">
      <li>
        <label for="#All">All Projects</label>
      </li>
      <li>
        <label for="#ProductDesign">Product Design</label>
      </li>
      <li>
        <label for="#AugmentedReality">Augmented Reality</label>
      </li>
      <li>
        <label for="#Health">Health</label>
      </li>
      <li>
        <label for="#Community">Community</label>
      </li>
    </ol> -->

    <ol data-aos="fade-up" class="posts">
      <li class="post" data-category="#ProductDesign #Health">
        <article>
          <figure>
            <a routerLink="/waivethewait">
              <img src="assets/images/wtwmock.jpg" alt="WaiveTheWait cover">
            </a>
            <figcaption>
              <!-- <ol class="post-categories">
                <li >
                  <a href="https://webdevtrick.com/portfolio-filter-gallery/">...</a>
                <li>
              </ol> -->
              <a routerLink="/waivethewait">
                <h2 class="post-title">Smart Room | Virtual clinic wait room</h2>
                <p>Product Design, UI/UX</p>
              </a>
            </figcaption>
          </figure>
        </article>
      </li>
      <!-- <li class="post" data-category="#AugmentedReality #Community #ProductDesign">
        <article>
          <figure>
            <a routerLink="/virtual-branch-support">
              <img src="assets/images/vbsmock.jpg" alt="VBS cover">
            </a>
            <figcaption>
              <a routerLink="/virtual-branch-support">
                <h2 class="post-title">Virtual Branch Support | AR advising application</h2>
                <p>AR Product Design</p>
              </a>
            </figcaption>
          </figure>
        </article>
      </li> -->
      <li class="post" data-category="#ProductDesign">
        <article>
          <figure>
            <a routerLink="/checkr">
              <img src="assets/images/checkrmock.jpg" alt="Checkr cover">
            </a>
            <figcaption>
              <a routerLink="/checkr">
                <h2 class="post-title">Checkr | A holistic solution for preventing forgetfulness</h2>
                <p>Product Design, UI/UX</p>
              </a>
            </figcaption>
          </figure>
        </article>
      </li>
      <li class="post" data-category="">
        <article>
          <figure>
            <a routerLink="/togetherapart">
              <img src="assets/projects/togetherapart/togetherapart.png" alt="together apart cover">
            </a>
            <figcaption>
              <a routerLink="/togetherapart">
                <h2 class="post-title">Together Apart | Redefining Remote Co-Dining Interactions</h2>
                <p>User Experience, HCI Research, Industrial Design, Non-traditional Interfaces</p>
              </a>
            </figcaption>
          </figure>
        </article>
      </li>
      <li class="post" data-category="#AugmentedReality">
        <article>
          <figure>
            <a routerLink="/arblockbot">
              <img src="assets/images/steps-cover.jpg" alt="ARBlockbot cover">
            </a>
            <figcaption>
              <a routerLink="/arblockbot">
                <h2 class="post-title">ARBlockbot | An accessible robotics learning platform</h2>
                <p>Product Design, UI/UX, Game Design/ Development</p>
              </a>
            </figcaption>
          </figure>
        </article>
      </li>
      <!-- <li class="post" data-category="#AugmentedReality">
        <article>
          <figure>
            <a routerLink="/filter">
              <img src="assets/images/filter.jpg" alt="Face filter cover">
            </a>
            <figcaption>
              <a routerLink="/filter">
                <h2 class="post-title">Personal Inquiry | Are face filters filtering out an authentic you?</h2>
                <p>Product Design, UI/UX</p>
              </a>
            </figcaption>
          </figure>
        </article>
      </li> -->
      <li class="post" data-category="#AugmentedReality">
        <article>
          <figure>
            <a routerLink="/volta">
              <img src="assets/images/voltacover.png" alt="volta cover">
            </a>
            <figcaption>
              <a routerLink="/volta">
                <h2 class="post-title">Volta | Platform Puzzle Game Design</h2>
                <p>Game Design and development</p>
              </a>
            </figcaption>
          </figure>
        </article>
      </li>
      <li class="post" data-category="#AugmentedReality">
        <article>
          <figure>
            <a routerLink="/compsa">
              <img src="assets/images/compsamock.jpg" alt="Compsa cover">
            </a>
            <figcaption>
              <a routerLink="/compsa">
                <h2 class="post-title">COMPSA | Marketing and Graphic Design</h2>
                <p>Design, Marketing, Social Media</p>
              </a>
            </figcaption>
          </figure>
        </article>
      </li>
    </ol>
  </div>

